// extracted by mini-css-extract-plugin
module.exports = {"list":"todo_list__1trVX","delite":"todo_delite__CJ9J9","check":"todo_check__10pIh","name":"todo_name__2yq9J","checked":"todo_checked__4VgbG"};